export const gtmAddToCartGa4Event = (
  productData: any,
  orderId: number,
  currency: string,
  value: string,
  quantity: number,
  discount: string,
) => ({
  event: 'add_to_cart',
  items: [
    {
      orderId,
      currency,
      value,
      item_id: productData.id,
      publicDesignId: productData.publicDesignId,
      customerDesignId: productData.customerDesignId,
      customerOrderId: orderId,
      item_name: productData.name,
      item_category: productData.category,
      affiliation: productData.marketing_material,
      family_id: productData.family_id,
      item_brand: productData.brand,
      price: productData.price,
      totalPriceExclVat: null,
      quantity,
      coupon: null,
      discount,
      index: null,
      item_list_id: null,
      item_list_name: null,
    },
  ],
});

export default gtmAddToCartGa4Event;
